export default {
  // Commission Config
  'pages.commissionConfig.title': '返佣配置',
  'pages.commissionConfig.levelTable.title': 'S等级配置',
  'pages.commissionConfig.col.level': '等级',
  'pages.commissionConfig.col.threshold': '业绩阈值 (USDT)',
  'pages.commissionConfig.col.rate': '级差费率 (%)',
  'pages.commissionConfig.directRate': '直推返佣费率',
  'pages.commissionConfig.directRate.desc': '直推奖励默认费率',
  'pages.commissionConfig.save': '保存配置',
  'pages.commissionConfig.saving': '保存中...',
  'pages.commissionConfig.recalculate': '重新计算所有业绩',
  'pages.commissionConfig.recalculate.confirm': '确定要重新计算所有用户的业绩数据吗？此操作可能需要较长时间。',
  'pages.commissionConfig.msg.loadFail': '加载配置失败',
  'pages.commissionConfig.msg.saveSuccess': '配置保存成功',
  'pages.commissionConfig.msg.saveFail': '保存配置失败',
  'pages.commissionConfig.msg.recalcSuccess': '业绩重算已启动',
  'pages.commissionConfig.msg.recalcFail': '启动业绩重算失败',
  'pages.commissionConfig.refresh': '刷新',

  // Commission Records
  'pages.commissionRecords.title': '返佣记录',
  'pages.commissionRecords.col.time': '时间',
  'pages.commissionRecords.col.beneficiary': '受益人',
  'pages.commissionRecords.col.triggerUser': '触发用户',
  'pages.commissionRecords.col.rewardType': '奖励类型',
  'pages.commissionRecords.col.baseAmount': '购买金额',
  'pages.commissionRecords.col.rate': '返佣比例',
  'pages.commissionRecords.col.amount': '返佣金额 (USDT)',
  'pages.commissionRecords.col.status': '状态',
  'pages.commissionRecords.filter.userId': '按用户ID或钱包地址筛选',
  'pages.commissionRecords.filter.rewardType': '奖励类型',
  'pages.commissionRecords.filter.status': '状态',
  'pages.commissionRecords.filter.direct': '直推奖励',
  'pages.commissionRecords.filter.levelDiff': '级差奖励',
  'pages.commissionRecords.filter.pending': '待处理',
  'pages.commissionRecords.filter.credited': '已到账',
  'pages.commissionRecords.filter.failed': '失败',
  'pages.commissionRecords.search': '搜索',
  'pages.commissionRecords.refresh': '刷新',
  'pages.commissionRecords.total': '共 {total} 条记录',
  'pages.commissionRecords.stats.totalCommissions': '返佣总额 (USDT)',
  'pages.commissionRecords.stats.totalCount': '返佣总笔数',
  'pages.commissionRecords.stats.directTotal': '直推奖励总额',
  'pages.commissionRecords.stats.levelDiffTotal': '级差奖励总额',
  'pages.commissionRecords.msg.loadFail': '加载返佣记录失败',

  // Team Performance
  'pages.teamPerformance.title': '团队业绩查询',
  'pages.teamPerformance.search.placeholder': '输入用户ID或钱包地址查询',
  'pages.teamPerformance.search': '查询',
  'pages.teamPerformance.userInfo': '用户信息',
  'pages.teamPerformance.userInfo.level': '当前等级',
  'pages.teamPerformance.userInfo.totalPerformance': '总业绩 (USDT)',
  'pages.teamPerformance.userInfo.largeArea': '大区业绩 (USDT)',
  'pages.teamPerformance.userInfo.smallArea': '小区业绩 (USDT)',
  'pages.teamPerformance.earnings': '收益信息',
  'pages.teamPerformance.earnings.total': '总收益 (USDT)',
  'pages.teamPerformance.earnings.direct': '直推收益 (USDT)',
  'pages.teamPerformance.earnings.levelDiff': '级差收益 (USDT)',
  'pages.teamPerformance.earnings.pending': '待结算 (USDT)',
  'pages.teamPerformance.userInfo.wallet': '钱包地址',
  'pages.teamPerformance.userInfo.directCount': '直推人数',
  'pages.teamPerformance.teamSize': '团队规模',
  'pages.teamPerformance.levelDist': '等级分布',
  'pages.teamPerformance.tab.tree': '团队树',
  'pages.teamPerformance.tab.table': '成员列表',
  'pages.teamPerformance.tree.perf': '业绩',
  'pages.teamPerformance.tree.empty': '暂无团队成员',
  'pages.teamPerformance.col.wallet': '钱包',
  'pages.teamPerformance.col.level': '等级',
  'pages.teamPerformance.col.depth': '层级',
  'pages.teamPerformance.col.depthLv': '第{val}层',
  'pages.teamPerformance.col.performance': '业绩',
  'pages.teamPerformance.col.smallArea': '小区业绩',
  'pages.teamPerformance.col.earnings': '收益',
  'pages.teamPerformance.col.direct': '直推',
  'pages.teamPerformance.col.custody': '托管',
  'pages.teamPerformance.col.yes': '是',
  'pages.teamPerformance.col.no': '否',
  'pages.teamPerformance.changeLevel': '修改等级',
  'pages.teamPerformance.changeLevel.title': '修改用户等级',
  'pages.teamPerformance.changeLevel.label': '新等级',
  'pages.teamPerformance.msg.loadFail': '查询失败',
  'pages.teamPerformance.msg.levelChangeSuccess': '等级修改成功',
  'pages.teamPerformance.msg.levelChangeFail': '等级修改失败',
  'pages.teamPerformance.msg.inputUserId': '请输入用户ID或钱包地址',
  'pages.teamPerformance.customRate': '自定义费率',
  'pages.teamPerformance.customRate.title': '自定义返佣费率',
  'pages.teamPerformance.customRate.levelDiff': '级差费率 (%)',
  'pages.teamPerformance.customRate.custom': '自定义',
  'pages.teamPerformance.customRate.global': '全局',
  'pages.teamPerformance.customRate.direct': '直推费率 (%)',
  'pages.teamPerformance.customRate.remark': '备注',
  'pages.teamPerformance.customRate.remarkPlaceholder': '自定义费率的原因',
  'pages.teamPerformance.msg.customRateSuccess': '自定义费率已更新',
  'pages.teamPerformance.msg.customRateFail': '更新自定义费率失败',
  'pages.teamPerformance.userInfo.customRate': '自定义级差费率',
  'pages.teamPerformance.userInfo.customDirectRate': '自定义直推费率',
  'pages.teamPerformance.userInfo.customRateRemark': '费率备注',
  'pages.teamPerformance.changeLevel.auto': '自动',
};
